export default __webpack_public_path__ + "static/media/jnh9.a1b018b8.jpg";